import Swiper, {
	Autoplay,
	EffectFade,
	Grid,
	Navigation,
	Pagination,
	Thumbs,
} from "swiper";
/**
 * @param swiperInit
 */
export default function swiperInit() {
	var slideAboutThumb = new Swiper(".about-3 .swiper-thumb .swiper", {
		modules: [Grid],
		slidesPerView: 2,
		spaceBetween: 30,
		grid: {
			rows: 3,
		},
		watchSlidesProgress: true,
		breakpoints: {
			768: {
				slidesPerView: 3,
			},
			1280: {
				slidesPerView: 3,
				spaceBetween: 0,
			},
		},
	});

	var slideAboutDetail = new Swiper(".about-3 .swiper-detail .swiper", {
		modules: [Navigation, Autoplay, Thumbs],
		slidesPerView: 1,
		autoplay: {
			delay: 3000,
		},
		thumbs: {
			swiper: slideAboutThumb,
		},
		navigation: {
			nextEl: `.about-3 .btn-next`,
			prevEl: `.about-3 .btn-prev`,
		},
	});

	var slideProductOther = new Swiper(".product-other-swiper .swiper", {
		modules: [Navigation, Autoplay],
		slidesPerView: 1,
		spaceBetween: 15,
		autoplay: {
			delay: 3000,
		},
		navigation: {
			nextEl: `.product-other-swiper .btn-next`,
			prevEl: `.product-other-swiper .btn-prev`,
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
				spaceBetween: 15,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
	});

	var slideProductDetail = new Swiper(".product-detail-thumb .swiper", {
		modules: [Navigation, Autoplay],
		slidesPerView: 1,
		spaceBetween: 15,
		autoplay: {
			delay: 3000,
		},
		navigation: {
			nextEl: `.product-detail-thumb .btn-next`,
			prevEl: `.product-detail-thumb .btn-prev`,
		},
	});

	var slideProductComfort = new Swiper(".product-detail-comfort .swiper", {
		modules: [Navigation, Autoplay],
		slidesPerView: 2,
		autoplay: {
			delay: 3000,
		},
		navigation: {
			nextEl: `.product-detail-comfort .btn-next`,
			prevEl: `.product-detail-comfort .btn-prev`,
		},
		breakpoints: {
			576: {
				slidesPerView: 4,
			},
			1024: {
				slidesPerView: 6,
			},
		},
	});

	var homeBanner = new Swiper(".home-banner .swiper", {
		modules: [Autoplay, Pagination],
		slidesPerView: 1,
		// autoplay: {
		// 	delay: 3000,
		// },
		pagination: {
			el: ".home-banner .swiper-pagination",
			type: "bullets",
			clickable: true,
		},
	});

	var homeBanner = new Swiper(".page-banner .swiper", {
		modules: [Autoplay],
		slidesPerView: 1,
		autoplay: {
			delay: 3000,
		},
	});

	var home2 = new Swiper(".home-2-swiper .swiper", {
		modules: [Autoplay, Navigation],
		slidesPerView: 3,
		spaceBetween: 10,
		autoplay: {
			delay: 3000,
		},
		navigation: {
			nextEl: `.home-2-swiper .btn-next`,
			prevEl: `.home-2-swiper .btn-prev`,
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1280: {
				slidesPerView: 5,
				spaceBetween: 44,
			},
		},
	});

	var home3 = new Swiper(".home-3-swiper .swiper", {
		modules: [Autoplay, Pagination],
		slidesPerView: 1,
		autoHeight: true,
		loop: false,
		autoplay: {
			delay: 3000,
		},
		pagination: {
			el: ".home-3-swiper .swiper-pagination",
			type: "bullets",
			clickable: true,
		},
	});
}
